/**
 * Route Constants
 * File to hold constants related to routing.
 */

export const SHOP = {
  STORE_TYPE: 'shop',
  BASE_URL: 'https://shop.glowforge.com',
  BASE_PRODUCT_URL: 'https://shop.glowforge.com/collections/printers',
  ENABLED: true,
};

export const CATALOG = {
  STORE_TYPE: 'catalog',
  BASE_URI: '/catalog',
  BASE_PRODUCT_URI: '/catalog/product',
  BASE_CATEGORY_URI: '/catalog/category',
  SEARCH_URI: '/catalog/search',
  PAGE_TITLE: 'Design Catalog',
  SEARCH_PLACEHOLDER_TEXT: 'Search for Designs',
  SHOW_CART: false,
  SHOW_SEARCH: true,
  ENABLED: false,
};

export const GLOWFORGE_CONFIRMATION = {
  BASE_URI: '/confirmation',
  SHOW_GLOBAL_FOOTER: true,
  USE_MARKETING_NAV: true,
  HIDE_NAV_LINKS: true,
};

export const SUPPORT = {
  BASE_URI: '/support',
  SHOW_CART: false,
  SHOW_SEARCH: false,
  SUPPORT_ENTRY_TYPES: [
    'questionAndAnswer',
    'supportEntryInstructions',
    'supportEntryTextAndMedia',
    'supportEntryTipOrAlert',
  ],
};

export const SETTINGS = {
  PAGE_TITLE: 'User Settings',
  BASE_URI: '/settings',
};

export const CREATE_ACCOUNT = {
  PAGE_TITLE: 'Create Account',
  BASE_URI: '/create-account',
  USE_MARKETING_NAV: true,
};

export const REFERRAL_PAYMENT = {
  PAGE_TITLE: 'Referral Payment',
  BASE_URI: '/referral-payment',
};

export const SETTINGS_ACCEPT_INVITE = {
  PAGE_TITLE: 'User Create',
  BASE_URI: '/settings/invite/accept',
  HIDE_NAV_LINKS: true,
  HIDE_USER_SECTION: true,
};

export const MARKETING = {
  BASE_URI: '/m/',
  USE_MARKETING_NAV: true,
  INCLUDE_BUY_BUTTON: true,
};

export const SETUP = {
  PAGE_TITLE: 'Glowforge',
  BASE_URI: '/setup',
  HIDE_NAV_LINKS: true,
  HIDE_USER_SECTION: true,
};

export const GLOWFORGE_LANDING_PAGE = {
  PAGE_TITLE: 'Glowforge - the 3D laser printer',
  BASE_URI: '/',
  USE_MARKETING_NAV: true,
  INCLUDE_BUY_BUTTON: true,
  SHOW_GLOBAL_FOOTER: true,
};

export const GLOWFORGE_LANDING_PAGE_HOME = {
  ...GLOWFORGE_LANDING_PAGE,
  BASE_URI: '/home',
  INCLUDE_BUY_BUTTON: true,
  CANONICAL_URI: '/',
};

export const GLOWFORGE_LANDING_PAGE_HOME_CDN_TEST = {
  ...GLOWFORGE_LANDING_PAGE,
  BASE_URI: '/home-2',
  INCLUDE_BUY_BUTTON: true,
  CANONICAL_URI: '/',
};

export const PAGE_NOT_FOUND = {
  BASE_URI: '/404',
  USE_MARKETING_NAV: true,
  SHOW_GLOBAL_FOOTER: true,
};

export const LOGIN = {
  PAGE_TITLE: 'Sign In',
  BASE_URI: '/login',
  USE_MARKETING_NAV: true,
  SHOW_GLOBAL_FOOTER: true,
};

export const COMMON = {
  PAGE_ERRORS: {
    PAGE_NOT_FOUND: '404',
    NOT_AUTHENTICATED: '401',
  },
};



// WEBPACK FOOTER //
// ./app/route-constants.js